import 'components/discovery/store-locator/components/store-card/store-card.js'
import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, queryAll, state } from 'lit/decorators.js'
import { STORE_LOCATOR_STORE, StoreLocatorStore } from 'components/discovery/store-locator/store-locator-store.js'

import { InternalStore } from 'components/discovery/store-locator/typing/store-locator.js'
import { style } from './store-list.style.js'


import { CSCStoreCard } from 'components/discovery/store-locator/components/store-card/store-card.js'
import { Debouncer, DEBOUNCER } from '@cloudsuite/mosaic-shared/scripts/debounce.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { createEffect } from '@cloudsuite/mosaic-shared/scripts/signals.js'

initializeIconsByRole({
  'csc-stores-list.arrow-up': { name: 'arrow-up', style: 'light' },
  'csc-stores-list.arrow-down': { name: 'arrow-down', style: 'light' }
})

@customElement('csc-store-list')
export class CSCStoreList extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @inject(STORE_LOCATOR_STORE)
  storeLocatorStore!: StoreLocatorStore

  @inject(DEBOUNCER)
  debounce!: Debouncer

  @state()
  stores!: InternalStore[]

  @queryAll('csc-store-card')
  cards!: CSCStoreCard[]

  constructor() {
    super()

    createEffect(() => {
      this.stores = this.storeLocatorStore.stores().stores

      this.storeLocatorStore.selectedStore()

      const selected = Array.from(this.cards).find(store => Number(store.id) === this.storeLocatorStore.selectedStore()?.id)
      if (selected) {
        selected.scrollIntoView(false)
      }
    })
  }

  override render() {
    return html`
      <cse-group class="csc-stores-list" direction="column">
        ${this.stores.map(store => html`
          <csc-store-card id="${store.id}" .store="${store}"></csc-store-card>
        `)}
      </cse-group>
    `
  }
}
